<template>
    <div>
        <b-row>
            <b-col xl="3">
                <places-list @selected="[barcode = $event.barcode, search()]" :items="notAcceptedPlaces" :group-by="groupBy" :show-group-buttons="true" header="Ожидают приёмки"></places-list>
            </b-col>
            <b-col xl="6">
                <h4>Приемка отправлений</h4>
                <b-form inline class="d-flex" @submit.prevent="search">
                    <b-form-input ref="searchInput" v-model="barcode" @focus="$event.target.select()" type="text" placeholder="Введите штрихкод отправления" class="flex-grow-1 mr-3" required></b-form-input>
                    <b-button type="submit">Поиск</b-button>
                </b-form>
                <div v-if="place !== null">
                    <hr>
                    <place-accept-card @accept="onAccept" :place="place" :sticker-date="defaultStickerDate" :controls="placeAcceptCardControls" :accept-btn-text="!place.accepted ? 'Принять' : 'Подтвердить'"></place-accept-card>
                </div>
                <div class="mt-5">
                    <h5>Последние принятые:</h5>
                    <b-table ref="lastAcceptedPlacesTable" @row-clicked="onLastAcceptedSelect" :items="lastAcceptedPlaces" :fields="lastAcceptedTableFields">
                        <template v-slot:cell(acceptTs)="data">{{ data.item.acceptTs ? data.item.acceptTs.replace('T', ' ') : '' }}</template>
                    </b-table>
                </div>
            </b-col>
            <b-col xl="3">
                <div class="mb-5">
                    <div>Дата сдачи на Почту России</div>
                    <date-picker v-model="defaultStickerDate"></date-picker>
                </div>
                <div>
                    <places-list @selected="[barcode = $event.barcode, search()]" :items="errorPlaces" :group-by="groupBy" :show-group-buttons="false" header="Проблемы"></places-list>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import axios from "axios";
    import NotificationMixin from "../mixins/NotificationMixin";
    import PlaceAcceptCard from "../common/PlaceAcceptCard";
    import PlacesList from "../common/PlacesList";
    import FindPlaceByBarcodeMixin from "../mixins/FindPlaceByBarcodeMixin";
    import LoadEntitiesMixin from "../mixins/LoadEntitiesMixin";

    export default {
        name: "ShipmentAcceptScreen",

        components: {
            PlaceAcceptCard,
            PlacesList,
        },

        mixins: [
            NotificationMixin,
            FindPlaceByBarcodeMixin,
            LoadEntitiesMixin,
        ],

        data() {
            return {
                barcode: '',
                place: null,
                notAcceptedPlaces: [],
                lastAcceptedPlaces: [],
                errorPlaces: [],
                groupBy: 'sender',
                defaultStickerDate: localStorage.getItem('defaultStickerDate'),
                lastAcceptedTableFields: [
                    {
                        key: 'acceptTs',
                        label: 'Принято',
                    }, {
                        key: 'barcode',
                        label: 'Штрихкод',
                    }, {
                        key: 'shipment.num',
                        label: 'Отправление',
                    }, {
                        key: 'shipment.dlvLogin',
                        label: 'Аккаунт',
                    }, {
                        key: 'shipment.courierCode',
                        label: 'Доставка',
                    },
                ],
            };
        },

        computed: {
            placeAcceptCardControls() {
                let result = ['printStickerBtn'];
                if (this.place && (!this.place.accepted || this.place.shipment.error)) {
                    result.push('acceptBtn');
                }
                if (this.place && this.place.shipment && this.place.shipment.courierCode === 'RussianPost') {
                    result.push('stickerDateInput')
                }
                return result;
            },
        },

        watch: {
            defaultStickerDate: function (val, oldVal) {
                localStorage.setItem('defaultStickerDate', val);
            },
        },

        mounted() {
            this.refresh();
        },

        methods: {
            refresh() {
                this.search();
                this.notAcceptedPlaces = [];
                this.errorPlaces = [];
                this.loadNotAcceptedPlaces();
                this.loadLastAccepted();
                this.loadErrorPlaces();
            },

            search() {
                this.findPlaceByBarcode(this.barcode).then(result => this.place = result);
            },

            loadNotAcceptedPlaces() {
                this.loadEntities(this.notAcceptedPlaces, '/api/places', [
                    {
                        key: 'accepted',
                        value: false,
                        operation: '=',
                    },
                    {
                        key: 'shipment.gatherRegister',
                        value: 'isNotNull',
                        operation: 'NULL',
                    },
                ], 'shipment.pickUpDate', 'ASC');
            },

            loadLastAccepted() {
                this.loadEntities(this.lastAcceptedPlaces, '/api/places', [
                    {
                        key: 'accepted',
                        value: true,
                        operation: '=',
                    },
                ], 'acceptTs', 'DESC');
            },

            loadErrorPlaces() {
                this.loadEntities(this.errorPlaces, '/api/places', [
                    {
                        key: 'shipment.error',
                        value: 'isNotNull',
                        operation: 'NULL',
                    },
                ], 'shipment.pickUpDate', 'ASC');
            },

            onAccept(place, placeDimension) {
                if (place) {
                    if (!place.accepted) {
                        this.acceptPlace(place, placeDimension);
                    } else if (place.shipment.error) {
                        this.commitShipment(place);
                    }
                }
            },

            acceptPlace(place, placeDimension) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + '/api/acceptPlace',
                    method: 'POST',
                    data: {
                        placeId: place.dlvPlaceId,
                        dimension: {
                            weight: placeDimension.weight,
                            width: placeDimension.width,
                            height: placeDimension.height,
                            depth: placeDimension.depth,
                        },
                    },
                }).then(resp => {
                    if (resp.data.success) {
                        this.refresh();
                        this.showSuccess('Место принято');
                        this.$refs.searchInput.focus();
                    } else {
                        this.showErrors(resp.data.errors);
                    }
                }).catch(err => {
                    this.showErrors(err.response.data.errors);
                })
            },

            commitShipment(place) {
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + '/api/commit-shipment',
                    method: 'POST',
                    data: {
                        id: place.shipment.id,
                    },
                }).then(resp => {
                    if (resp.data.success) {
                        this.refresh();
                        this.showSuccess('Место принято');
                    } else {
                        this.showErrors(resp.data.errors);
                    }
                }).catch(err => {
                    this.showErrors(err.response.data.errors);
                })
            },

            onLastAcceptedSelect(item) {
                this.barcode = item.barcode;
                this.search();
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>